// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__16OM0","location":"Header_location__2kQO_"};